// extracted by mini-css-extract-plugin
export var benefit = "styles-module--benefit--8aaCn";
export var body = "styles-module--body--U1jsA";
export var ctaButton = "styles-module--ctaButton--DEuvc";
export var des = "styles-module--des--pJAuH";
export var header = "styles-module--header--3tZ3B";
export var item = "styles-module--item--+yRdY";
export var label = "styles-module--label--AgFAz";
export var list = "styles-module--list--a91Id";
export var price = "styles-module--price--FLlH9";